import styled from '@emotion/styled'
import { Switch, type SwitchProps } from '@mui/material'
import { theme as newTheme } from 'styles/theme/hav-theme'

interface SwitchStyledProps extends SwitchProps {
  width?: number
  height?: number
  padding?: number | string
  margin?: number | string
  paddingleft?: number | string
  switchsize?: number
  borderradius?: number
  transitionduration?: string
}

export const SwitchStyled = styled(Switch)<SwitchStyledProps>`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  padding: ${({ padding }) => padding};

  & .MuiSwitch-switchBase {
    padding: 0;
    margin: ${({ margin }) => margin}px;
    padding-left: ${({ paddingleft }) => paddingleft}px;
    transition-duration: ${({ transitionduration }) => transitionduration};

    & + .muiswitch-thumb {
      box-sizing: 'border-box';
      width: ${({ switchsize }) => switchsize}px;
      height: ${({ switchsize }) => switchsize}px;
    }

    & + .MuiSwitch-track {
      border-radius: ${({ borderradius }) => borderradius}px;
      background-color: ${newTheme.colors.neutral.light};
      opacity: 1;
      transition: background-color 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }

    &.Mui-checked {
      transform: ${({ size }) => (size === 'small' ? 'translateX(10px)' : 'translateX(19px)')};
      color: ${newTheme.colors.neutral.white};

      & + .MuiSwitch-track {
        background-color: ${newTheme.colors.primary.main};
        opacity: 1;
        border: 0;
        border-radius: ${({ borderradius }) => borderradius}px;
      }

      &.Mui-disabled .muiswitch-thumb {
        color: ${newTheme.colors.neutral.light};
      }
    }
    &.Mui-disabled {
      color: transparent;
      outline: solid 1px ${newTheme.colors.neutral.lighthover};
      outline-offset: -1px;
      box-shadow: none;

      & + .MuiSwitch-track {
        cursor: not-allowed;
        opacity: 1;
        background-color: transparent;
        outline: solid 1px ${newTheme.colors.neutral.lighthover};
        outline-offset: -1px;
        box-shadow: none;
      }
    }
  }
`
